
import { spreadList } from './type'
import spreadData from "../../../data/spreadData.json";

export class fxSpreadService {
  async getSpreadList(): Promise<spreadList[]> {
    const data = spreadData.data
    return data;
  }

  async updateSpread(spread: spreadList[]) {
    spread.forEach(spreadItem => {
      const index = spreadData.data.findIndex(item => item.id === spreadItem.id)
      if (index !== -1) {
        spreadData.data[index] = spreadItem
      }
    })
    
    // Aquí deberías hacer la llamada al backend
    // Por ejemplo:
    // const response = await axios.put('/api/spreads', spread)
    // return response.data
    
    return spread
  }
}
